<script setup lang="ts">
interface Props {
  modelValue: number
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
}
const {
  modelValue,
  size = 'md',
  disabled = false
} = defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()
const hoveredRating = ref(0)
const isHovering = ref(false)
const handleMouseEnter = (rating: number) => {
  if (disabled) return
  hoveredRating.value = rating
  isHovering.value = true
}
const handleMouseLeave = () => {
  hoveredRating.value = 0
  isHovering.value = false
}
const handleClick = (rating: number) => {
  if (disabled) return
  emit('update:modelValue', rating)
}
const sizeClasses = computed(
  () =>
    ({
      sm: 'w-4 h-4',
      md: 'w-5 h-5',
      lg: 'w-6 h-6'
    }[size])
)
const displayRating = computed(() =>
  isHovering.value ? hoveredRating.value : modelValue
)
</script>

<template>
  <div
    class="flex items-center gap-1"
    @mouseleave="handleMouseLeave"
  >
    <button
      v-for="i in 5"
      :key="i"
      type="button"
      class="focus:outline-none transition-colors duration-200"
      :class="[
        sizeClasses,
        disabled ? 'cursor-default' : 'cursor-pointer hover:scale-110'
      ]"
      @mouseenter="handleMouseEnter(i)"
      @click="handleClick(i)"
    >
      <Icon
        :name="
          i <= displayRating ? 'i-heroicons-star-solid' : 'i-heroicons-star'
        "
        class="w-full h-full"
        :class="i <= displayRating ? 'text-[#5f0ce2]' : 'text-[#5f0ce2]'"
      />
    </button>
  </div>
</template>
